import {
  Box,
  TextField,
  InputAdornment,
  Grid,
  FormControl,
  Button,
  Typography,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import React from "react";
import { sizes } from "../../setupUtils";
import CreateTransferList from "./CreateTransferList";
import CreateBasicModal from "./CreateBasicModal";
import { useDispatch, useSelector } from "react-redux";
import { getProductGroups, setPGState } from "../productGroupSetupSlice";
import CollapseSection from "../../../../components/ui/CollapseSection";
import SearchIcon from "@mui/icons-material/Search";

export default function CreateSelectSKU() {
  const pgState = useSelector((store) => store.productGroupSetup);
  const { country, skus, selectedSKUs, countryID, searchedPGName } = pgState;
  const dispatch = useDispatch();

  function showMessage(message, severity) {
    dispatch(setPGState("createMessageOpen", true));
    dispatch(setPGState("createMessage", message));
    dispatch(setPGState("createMessageSeverity", severity));
  }

  function updateSearchedPGName(event) {
    const name = event.target.value;
    dispatch(setPGState("searchedPGName", name));
  }

  function searchSKUs() {
    if (country.length <= 0) {
      showMessage("Please select a country", "info");
      return;
    }
    const productGroupName = searchedPGName;
    dispatch(getProductGroups({ countryID, productGroupName }));
  }
  return (
    <Box>
      <CollapseSection title="Select SKU to add">
        <Box sx={{ mt: 3 }}>
          {/*Main Grid Container with two sections-filters on left and transferlist on right*/}
          <Grid container columns={10} spacing={2} rowGap={2}>
            {/*Left side form controls*/}
            <Grid item xs={10} lg={2}>
              <Box sx={{ mt: 1, ml: -1 }}>
                <Grid container justifyContent="flex-end" spacing={2} pb={1}>
                  <Grid item sm={7.5} md={8.5} lg={11.5}>
                    <TextField
                      label="SKU"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="end">
                            <EditIcon />
                          </InputAdornment>
                        ),
                      }}
                      variant="standard"
                      value={searchedPGName}
                      onChange={updateSearchedPGName}
                    />
                  </Grid>

                  <Grid item xs={12} md={5.4} lg={11.5} sx={{ ml: 26 }}>
                    <Button
                      startIcon={<SearchIcon />}
                      sx={{
                        bgcolor: "darkBlue.light",
                        color: "white.main",
                        textTransform: "none",
                        mt: 1,
                        "&:hover": {
                          bgcolor: "darkBlue.main",
                        },
                      }}
                      onClick={searchSKUs}
                    >
                      <Typography
                        sx={{ fontWeight: "bold", color: "white.main" }}
                      >
                        Search
                      </Typography>
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </Grid>

            <Grid item sm={7} md={2.5} lg={8}>
              <Box
                sx={{
                  mt: 1,
                  p: 4,
                  ml: 1,
                  mr: -2,
                  borderLeft: 1,
                  borderColor: "#c6c6c6",
                }}
              >
                <FormControl className={"fullHeight"}>
                  <CreateTransferList
                    leftList={skus}
                    rightList={selectedSKUs}
                    leftState={"skus"}
                    rightState={"selectedSKUs"}
                  />
                </FormControl>
                <CreateBasicModal />
              </Box>
            </Grid>
          </Grid>
        </Box>
        {/* </Box> */}
      </CollapseSection>
    </Box>
  );
}
